import { render, staticRenderFns } from "./GrowingNumber.vue?vue&type=template&id=20b67c70&scoped=true&"
import script from "./GrowingNumber.vue?vue&type=script&lang=js&"
export * from "./GrowingNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b67c70",
  null
  
)

export default component.exports